import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormLayout from '~/components/formLayout/formLayout';

const renderInput = (name, label, errors, showError = true) => (
  <div className="mb3">
    <Label>{label}</Label>
    <FormikInputField name={name} invalid={showError && !!errors[name]} />
    {showError && errors.name && <p className="error">{errors[name]}</p>}
  </div>
);

const CustomerForm = ({ errors, touched, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Name">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Contact details">
        <div className="mb3">
          <Label>Contact person's name</Label>
          <FormikInputField name="contactName" />
        </div>
        <div className="mb3">
          <Label>Phone number</Label>
          <FormikInputField name="phone" />
        </div>
        <div className="mb3">
          <Label>Email address</Label>
          <FormikInputField name="email" invalid={!!errors.email} />
          {errors.email && (
            <p data-qa="email-error" className="error">
              {errors.email}
            </p>
          )}
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Address">
        {renderInput('streetAddress', 'Street address', errors)}
        {renderInput('streetAddress2', 'Street address 2', errors, false)}
        {renderInput('suburb', 'Suburb', errors, false)}
        {renderInput('city', 'City', errors)}
        {renderInput('postcode', 'Post code', errors)}
        <div className="mb3">
          <Label>Country</Label>
          <FormikInputField name="country" disabled />
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Other">
        <div className="mb3">
          <Label>Birth date</Label>
          <FormikInputField type="date" name="birthDate" />
        </div>
        <div className="mb3">
          <Label>FIN</Label>
          <FormikInputField name="fin" />
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Notes">
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton data-qa="customer-save" color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default CustomerForm;



// WEBPACK FOOTER //
// ./src/components/customerForm/customerForm.jsx